export const BASE_URL = process.env.REACT_APP_API_URL;

export const EXAMTYPES = ['Пробный 1', 'Пробный 2', 'Онлайн экзамен']; //, '1 тур', '2 тур'];
export const QUESTIONS_TYPES = [
  'Математика',
  'Грамотность чтения 1 (KZ)',
  'Грамотность чтения 2 (KZ)',
  'Грамотность чтения 1 (RU)',
  'Грамотность чтения 2 (RU)',
];
export const ANSWER_OPTIONS = ['A', 'B', 'C', 'D', 'E'];

export const CONTACT_PHONE = "+7 708 508 40 53";
export const WHATSAPP_CONTACT_PHONE = CONTACT_PHONE.replace(/\s/g, '');
export const WHATSAPP_TEXT = '%D0%A1%D3%99%D0%BB%D0%B5%D0%BC%D0%B5%D1%82%D1%81%D1%96%D0%B7%20%D0%B1%D0%B5!%20%D0%91%D0%98%D0%9B%20%D2%9B%D0%B0%D0%B1%D1%8B%D0%BB%D0%B4%D0%B0%D1%83%20%D0%B5%D0%BC%D1%82%D0%B8%D1%85%D0%B0%D0%BD%D1%8B%D0%BD%D0%B0%20%D0%B1%D0%B0%D0%B9%D0%BB%D0%B0%D0%BD%D1%8B%D1%81%D1%82%D1%8B%20%D1%81%D2%B1%D1%80%D0%B0%D2%93%D1%8B%D0%BC%20%D0%B1%D0%B0%D1%80%20%D0%B5%D0%B4%D1%96.%0A%0A%D0%97%D0%B4%D1%80%D0%B0%D0%B2%D1%81%D1%82%D0%B2%D1%83%D0%B9%D1%82%D0%B5!%20%D0%95%D1%81%D1%82%D1%8C%20%D0%B2%D0%BE%D0%BF%D1%80%D0%BE%D1%81%20%D0%BF%D0%BE%20%D0%BF%D0%BE%D0%B2%D0%BE%D0%B4%D1%83%20%D0%B2%D1%81%D1%82%D1%83%D0%BF%D0%B8%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D1%8B%D1%85%20%D1%8D%D0%BA%D0%B7%D0%B0%D0%BC%D0%B5%D0%BD%D0%BE%D0%B2%20%D0%B2%20%D0%91%D0%98%D0%9B.'
